import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Truck, ListChecks, Cctv, Users, Settings } from "lucide-react";
import GreenLogo from "../../images/svg/Greenlogo.svg";
import { setActiveTabLabel } from "../../Redux/CommonSlice/allDataSlice";
import { useSelector, useDispatch } from "react-redux";
import "./layout.css";

const SideNav = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [showLabels, setShowLabels] = useState(false); // State to control label display
  const location = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { user_permissions } = auth.user

  const sidebarItems = [
    {
      icon: <Truck size={25} className="text-black" />,
      label: "Vehicle Entries",
      path: "/",
    },
    {
      icon: <ListChecks size={25} className="text-black" />,
      label: "Vehicle Data",
      path: "/vehicle-data",
    },
    {
      icon: <Cctv size={25} className="text-black" />,
      label: "Camera Setting",
      path: "/cameras",
    },
    {
      icon: <Users size={25} className="text-black" />,
      label: "Users",
      path: "/users",
    },
    {
      icon: <Settings size={25} className="text-black" />,
      label: "Settings",
      path: "/settings",
    },
  ];

  useEffect(() => {
    if (!collapsed) {
      const timeout = setTimeout(() => {
        setShowLabels(true);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [collapsed]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    setShowLabels(false);
  };

  const handleNavLinkClick = (label) => {
    dispatch(setActiveTabLabel(label));
  };

  const getActiveTabLabel = () => {
    const activeItem = sidebarItems.find(
      (item) => item.path === location.pathname
    );
    return activeItem ? activeItem.label : "";
  };
const AccessPage=()=>{

let RoutenewList=[]
if(user_permissions?.screens.includes('vehicle_entries_page')){
  RoutenewList.push(sidebarItems[0])
}
if(user_permissions?.screens.includes('vehicle_details_page')){
  RoutenewList.push(sidebarItems[1])
}
if(user_permissions?.screens.includes('camera_settings_page')){
  RoutenewList.push(sidebarItems[2])
}
if(user_permissions?.screens.includes('users_page')){
  RoutenewList.push(sidebarItems[3])
}
if(user_permissions?.screens.includes('settings_page')){
  RoutenewList.push(sidebarItems[4])
}
if(user_permissions?.screens.includes('all')){
  RoutenewList=sidebarItems
}

  return RoutenewList
}

  return (
    <div
      className={`flex flex-col ${
        collapsed ? "w-[70px]" : "!w-[225px]"
      } h-[89vh] justify-between transition-all duration-300  ease-in-out`}
    >
      <div className="h-[405px] flex flex-col justify-start">
        <button
          onClick={toggleSidebar}
          className="flex items-start pl-4 pt-2"
          style={{ fontSize: "25px" }}
        >
          {collapsed ? (
            <i className="ri-menu-2-line"></i>
          ) : (
            <i className="ri-menu-3-line"></i>
          )}
        </button>
        <div className="sidebar-container">
          <div
            className={`flex flex-col items-start mt-[3rem] space-y-4  pr-[6px] ${
              !collapsed && showLabels ? "pl-4" : "pl-[6px]"
            }`}
          >
            {AccessPage()?.map((item, index) => (
              <NavLink
                key={index}
                to={item.path}
                className={`nav-link flex no-underline w-[100%]  ${
                  item.path == location.pathname ? "!bg-[#E7FFD9]" : ""
                } hover:bg-[#E7FFD9] ${
                  !collapsed && showLabels
                    ? "pl-3 gap-[1rem]"
                    : "justify-center !pl-[0px]"
                } items-center transition-all duration-300 ease-in-out rounded h-12 max-h-12 overflow-hidden whitespace-nowrap`}
                onClick={() => handleNavLinkClick(item.label)}
                title= {item.label}
              >
                {item.icon}

                <span
                  className={`text-black  ${
                    !collapsed && showLabels ? " text-[15px]" : "text-[0px]"
                  } `}
                >
                  {item.label}
                </span>
              </NavLink>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`w-full gap-[1rem] h-16 flex items-center ${
          !collapsed ? "justify-center" : "justify-start"
        }`}
      >
        <img
          src={GreenLogo}
          className={` ${!collapsed ? "ml-0" : "ml-4"}`}
          style={{ height: "30px", width: "30px" }}
        />
        {!collapsed && (
          <span className="w-[71px] text-black text-xs font-semibold font-['Open Sans']">
            Powered By Green Panel
          </span>
        )}
      </div>
    </div>
  );
};

export default SideNav;
